// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld/base/core';
import 'myWorld/base/control';

myw.CurrentAlertView = myw.Control.extend({
    tagName: 'div',
    className: 'overlay-container notification-popup',

    /*
     * @class Alert that pop's up at the bottom of the page
     *        Used in the phone layout
     * @constructs
     * @extends {Control}
     */
    initialize(options) {
        myw.Control.prototype.initialize.apply(this, arguments);
        this.render();
    },

    render() {
        this.datasourceView = $('<span>', { class: 'notification-title' });
        this.errorReasonView = $('<span>', { class: 'notification-desc' });

        this.$el
            .append(this.datasourceView)
            .append(this.errorReasonView)
            .appendTo('body')
            .hide();
    },

    updateAndShow(alert) {
        const title = alert.title ? alert.title : '';
        const notification = alert.description ? alert.description : alert;
        this.datasourceView.html(title);
        this.errorReasonView.html(notification);
        this.$el.show();
        this.waitAndHide();
    },
    /*
     * After waiting for 1 second, hide the alert
     */
    waitAndHide() {
        this.$el.delay(3000).fadeOut(1000);
    }
});
export default myw.CurrentAlertView;
